// extracted by mini-css-extract-plugin
module.exports = {"Role":"index-module_Role_1OG_v"};